// extracted by mini-css-extract-plugin
export default {"recommendation":"recommendations_recommendation__4+fxd","date-badge":"recommendations_date-badge__9lnxU","active":"recommendations_active__ayokL"};